/* eslint-disable */
window.addEventListener('load', () => {
  accordionBlock.init();
});

const accordionBlock = {
  init: function () {
    const sections = document.querySelectorAll('[data-accordion-block-js]');

    if (!sections.length) return;

    sections.forEach((section) => {
      this.initSection(section)
    })

  },

  initSection: function (section) {
    let accordionItems = section.querySelectorAll('[data-accordion-item-js]');
    if (!accordionItems.length) return;

    accordionItems.forEach((item) => {
      item.addEventListener('click', () => {
        if (item.classList.contains('active')) return;
        let activeItem = section.querySelector('[data-accordion-item-js].active');
        if (activeItem) {
          activeItem.classList.remove('active');
        }
        item.classList.add('active');
      })
    })
  }

}

export default accordionBlock;
